import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

import * as moment from 'moment';

@Component({
  selector: 'awair-weekpicker',
  templateUrl: './weekpicker.component.html',
  styleUrls: ['./weekpicker.component.scss']
})

export class WeekpickerComponent implements OnInit {

  private _since: Date;
  get since(): Date {
    return this._since;
  }
  @Input()
  set since(since: Date) {
    if (since != null) {
      this._since = since;

      this.fromStartOfWeek = moment(since).startOf('isoWeek').toDate();
      this.fromEndOfWeek = moment(since).endOf('isoWeek').toDate();

      this.toStartOfWeek = moment().subtract(1, 'w').startOf('isoWeek').toDate();
      this.toEndOfWeek = moment().subtract(1, 'w').endOf('isoWeek').toDate();

      const ascWeekList = this.getWeekList(this.fromStartOfWeek, this.toEndOfWeek);
      // Newest week to the top
      this.weekList = ascWeekList.reverse();
    }
  }

  @Input() selectedFromDate: Date;
  @Input() selectedToDate: Date;

  @Output() selectWeek: EventEmitter<IDateRange> = new EventEmitter();

  fromStartOfWeek: Date;
  fromEndOfWeek: Date;

  toStartOfWeek: Date;
  toEndOfWeek: Date;

  weekList: IDateRange[] = [];

  constructor() { }

  ngOnInit() {
  }

  onDropdownEvent(event: MouseEvent, dropdownContainer: HTMLElement): void {
    const dropdownEl: HTMLElement = dropdownContainer.querySelector('ul');

    if (!(dropdownContainer.contains(event.target as HTMLElement)) && dropdownEl) {
      // If selected element is not dropdown element,
      dropdownEl.style.display = 'none';

    } else if (dropdownEl) {
      // If selected element is dropdown element, make it toggle
      // On init, element's display is set to ''
      dropdownEl.style.display = dropdownEl.style.display === 'none' || dropdownEl.style.display === '' ? 'block' : 'none';
    }
  }

  onSelectWeek(fromDate: Date, toDate: Date): void {
    this.selectedFromDate = fromDate;
    this.selectedToDate = toDate;

    this.selectWeek.emit({ 'fromDate': fromDate, 'toDate': toDate });
  }

  getWeekList(fromStartOfWeek: Date, toEndOfWeek: Date): IDateRange[] {
    const weekList: IDateRange[] = [];
    let ctrDate: Date = new Date(fromStartOfWeek);

    while (ctrDate.getTime() < toEndOfWeek.getTime()) {
      weekList.push({
        fromDate: ctrDate,
        toDate: moment(ctrDate).endOf('isoWeek').toDate()
      });
      // Increase counter for 1 week
      ctrDate = moment(ctrDate).add(1, 'w').toDate();
    }

    return weekList;
  }
}

export interface IDateRange {
  fromDate: Date;
  toDate: Date;
}
